import { Box, Text } from '@user-portal/wikr-components';

import useModals from 'modals/hooks';

import Modal from 'components/Modal/Modal';
import HeaderWithLogo from '../../../../components/HeaderWithLogo';

import { BaseConfirmationModalProps } from './types';

import { features } from './config';

import AppFeatures from '../AppFeatures/AppFeatures';

const BaseConfirmationModal = ({
    onBackButtonClick,
    title,
    subtitle,
    children,
    dataTestId,
}: BaseConfirmationModalProps) => {
    const { closeModal } = useModals();

    return (
        <Modal
            isOpen
            onClose={closeModal}
            shouldCloseOnOverlayClick
            fullscreen
            withRoundedCorners={false}
            customStyles={{ padding: 0 }}
            dataTestId={dataTestId}
        >
            <HeaderWithLogo onBackButtonClick={onBackButtonClick} />
            <Box $paddingTop={24} $paddingBottom={16} data-locator="cancelSubModal" className="container-sm">
                <Text type="h5" mb={12}>
                    {title}
                </Text>
                <Text color="text-secondary" mb={32}>
                    {subtitle}
                </Text>

                <AppFeatures features={features} mb={40} />

                {children}
            </Box>
        </Modal>
    );
};

export default BaseConfirmationModal;
